import type { Messages } from "../types";

export const messages: Messages = {
  shared: {
    title: "Fielmann-Clientekonto",
    tabs: {
      login: "Aloggen",
      signup: "Kont erstellen",
      ariaLabel: "Authentifikatioun",
    },
    languageSwitcher: {
      label: "Sprooch auswielen",
    },
    password: {
      show: "Passwuert weisen",
      hide: "Passwuert verstoppen",
    },
    header: {
      logoAriaLabel: "Fielmann",
    },
    footer: {
      ariaLabel: "Fousszeil",
      customerService: "Clientsservice",
      legalNotice: "Impressum",
      dataProtection: "Dateschutz",
    },
    loading: {
      ariaLabel: "Ee Moment, wannechgelift...",
      content: "Inhalter ginn gelueden.",
    },
  },
  login: {
    subtitle: "Logg dech mat denger E-Mail-Adress an dengem Passwuert an.",
    form: {
      emailLabel: "E-Mail-Adress *",
      passwordLabel: "Passwuert *",
      forgotPassword: "Passwuert vergiess?",
      submitButton: "Aloggen",
      credentialError: "D'E-Mail-Adress an d'Passwuert passen net zesummen.",
      genericError:
        "Et ass e Feeler opgetrueden. Probéier et wannechgelift méi spéit nach eng Kéier.",
    },
  },
  signup: {
    subtitle: {
      before: "Notz d’",
      highlight: "Virdeeler",
      after: " a stell däi Fielmann-Clientekonto op.",
    },
    benefits: {
      popoverHeading: "Deng Virdeeler:",
      closeLabel: "Zoumaachen",
      items: {
        orders: "All Fielmann-Bestellunge mam Bestellstatus op ee Bléck.",
        visionValues: "Benotz deng Siichtwäerter fir deng nächst Bestellung.",
        appointments: "Maach Rendez-vousen a verwalt se.",
        reorders: "Bestell ganz einfach online no.",
      },
    },
    form: {
      firstNameLabel: "Virnumm *",
      lastNameLabel: "Familljennumm *",
      emailLabel: "E-Mail-Adress *",
      passwordLabel: "Passwuert *",
      passwordRepeatLabel: "Passwuert widderhuelen *",
      submitButton: "Kont erstellen",
      errorTitle: "De Kont konnt net erstallt ginn.",
      errorMessage:
        "Iwwerpréif deng Donnéeën oder probéier et méi spéit nach eng Kéier.",
      genericError:
        "Et ass e Feeler opgetrueden. Probéier et wannechgelift méi spéit nach eng Kéier.",
    },
    consents: {
      requiredError: "Gëff wannechgelift déi erfuerderlech Zoustëmmung.",
      unavailableError:
        "Et ass e Feeler opgetrueden. Probéier et wannechgelift méi spéit nach eng Kéier.",
      required: {
        headline: "Zoustëmmung zum Clientekonto",
        subline:
          "Fir datt mir dir all d'Inhalter an dengem Clientekonto weise kënnen (z. B. Akeef oder Rendez-vousen), brauche mir deng Zoustëmmung.",
      },
      optional: {
        headline: "Wëlls du personaliséiert Reklamm kréien?",
        subline:
          "Du kanns wielen: Mat denger Zoustëmmung kriss du Offeren an Informatiounen, déi op dech zougeschnidde sinn. Ouni Zoustëmmung benotz du däi Clientekonto ouni personaliséiert Reklamm.",
      },
    },
  },
  emailVerification: {
    subtitle: "Kanns de dech net aloggen?",
    alertTitle: "Bestäteg fir d’éischt deng E-Mail-Adress.",
    alertBody:
      "Bestäteg wannechgelift fir d’éischt deng E-Mail-Adress, fir däi Fielmann-Kont ze aktivéieren.",
    alertSpamHint: "Fënns de d’E-Mail net? Kuck och am Spam-Dossier no.",
    resendButton: "E-Mail nach eng Kéier ufroen",
    backToLogin: "Zeréck zum Aloggen",
  },
  setPassword: {
    subtitle: "Du kanns elo däi Passwuert festleeën.",
    emailLabel: "E-Mail-Adress *",
    passwordLabel: "Passwuert *",
    passwordRepeatLabel: "Passwuert widderhuelen *",
    submitButton: "Passwuert späicheren",
    backToLogin: "Zum Aloggen",
    successTitle: "Däi Passwuert gouf erfollegräich gespäichert.",
    successBody: "Du kanns dech elo aloggen.",
  },
  toasts: {
    missingRequiredFields:
      "Fëll wannechgelift all nach feelend Pflichtfelder aus, fir weiderzemaachen.",
  },
  validation: {
    passwordRequired: "Gëff wannechgelift e Passwuert an.",
    passwordRepeatRequired: "Gëff wannechgelift d'Passwuert nach eng Kéier an.",
    firstNameTooLong: "De Virnumm däerf net méi wéi 30 Zeeche laang sinn.",
    firstNameRequired: "Gëff wannechgelift e Virnumm an.",
    firstNameInvalidFormat: "Gëff wannechgelift e gültege Virnumm an.",
    lastNameTooLong: "De Familljennumm däerf net méi wéi 30 Zeeche laang sinn.",
    lastNameRequired: "Gëff wannechgelift e Familljennumm an.",
    lastNameInvalidFormat: "Gëff wannechgelift e gültege Familljennumm an.",
    emailTooLong: "D'E-Mail-Adress ass ze laang.",
    emailRequired: "Gëff wannechgelift eng E-Mail-Adress an.",
    emailInvalidFormat: "Gëff wannechgelift eng gülteg E-Mail-Adress an.",
    passwordMatchesEmail:
      "D'Passwuert däerf net d'selwecht sinn ewéi d'E-Mail-Adress.",
    passwordMismatch: "D'Passwierder stëmmen net iwwereneen.",
  },
  passwordRequirements: {
    minimumLength: "Op d'mannst 10 Zeechen",
    mixedCase: "Op d'mannst ee Grouss- an ee Klengbuchstaf",
    hasNumber: "Op d'mannst eng Zuel",
    specialCharactersAllowed: "Sonnerzeeche sinn erlaabt (z. B. !@#$%^&*)",
  },
};
